import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MobileGetStartedComponent } from './components/mobile-get-started/mobile-get-started.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-jc3-block-4',
    standalone: true,
    imports: [MobileGetStartedComponent, CommonModule],
    templateUrl: './jc3-block-4.component.html',
    styleUrl: './jc3-block-4.component.scss',
})
export class Jc3Block4Component implements OnChanges {
    @Input() gsData: any;
    cardsData: any = null;
    getStartedItems: { title: string; description: string; image: string }[];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['gsData']) {
            const current = changes['gsData'].currentValue;

            if (current?.cards && Object.keys(current.cards).length > 0) {
                this.cardsData = current.cards;
                this.getStartedItems = [
                    {
                        title: this.cardsData?.title1,
                        description: this.cardsData?.description1,
                        image: this.cardsData?.icon1_url,
                    },
                    {
                        title: this.cardsData?.title2,
                        description: this.cardsData?.description2,
                        image: this.cardsData?.icon2_url,
                    },
                    {
                        title: this.cardsData?.title3,
                        description: this.cardsData?.description3,
                        image: this.cardsData?.icon3_url,
                    },
                    {
                        title: this.cardsData?.title4,
                        description: this.cardsData?.description4,
                        image: this.cardsData?.icon4_url,
                    },
                    {
                        title: this.cardsData?.title5,
                        description: this.cardsData?.description5,
                        image: this.cardsData?.icon5_url,
                    },
                    {
                        title: this.cardsData?.title6,
                        description: this.cardsData?.description6,
                        image: this.cardsData?.icon6_url,
                    },
                ];
            }
        }
    }
}
